export function validateIban(string: string) {
  const rearrangedIban = `${string.slice(4)}${string.slice(0, 4)}`

  const convertedIban = rearrangedIban
    .split('')
    .map((ch) => {
      if (/\d/.test(ch)) {
        return ch
      }

      return (ch.charCodeAt(0) - 55).toString()
    })
    .join('')

  let remainder = ''

  for (let i = 0; i < convertedIban.length; i += 7) {
    const part = remainder + convertedIban.substring(i, i + 7)
    remainder = (parseInt(part, 10) % 97).toString()
  }

  return parseInt(remainder, 10) === 1
}
